import type { BottomSheetInstance } from '../../../components/bottomSheet/types';
import { useCoreSelector } from '../../CoreStore';

import type { HeaderModal } from './types';

export const useHeaderSlice = {
  getCoreBetLimitsOpen: (): boolean => {
    return useCoreSelector(({ header }) => header.betLimitsOpen);
  },
  getCoreOpenedModal: (): HeaderModal | null => {
    return useCoreSelector(({ header }) => header.openedModal);
  },
  getCoreOpenedBottomSheetModal: (): BottomSheetInstance | null => {
    return useCoreSelector(({ header }) => header.openedBottomSheetModal);
  },
  getCoreOpenedDrawer: (): BottomSheetInstance | null => {
    return useCoreSelector(({ header }) => header.openedDrawer);
  },
  isBottomSheetOpen: (instance: BottomSheetInstance): boolean => {
    return useCoreSelector(({ header }) => header.openedBottomSheets[instance]);
  },
  getIsMiniLobbyOpen: (): boolean => {
    return useCoreSelector(({ header }) => header.isMiniLobbyOpen);
  },
  getIsBackToGameHidden: (): boolean => {
    return useCoreSelector(({ header }) => header.isBackToGameHidden);
  },
  getNavExpanded: (): boolean => {
    return useCoreSelector(({ header }) => header.navExpanded);
  },
  getNavForcedExpanded: (): boolean => {
    return useCoreSelector(({ header }) => header.navForcedExpanded);
  },
  getNavRoute: (): string[] => {
    return useCoreSelector(({ header }) => header.navRoute);
  },
  getNavOpen: (): boolean => {
    return useCoreSelector(({ header }) => header.navRoute.length > 0);
  },
  getNavRouteLevel: (): number => {
    return useCoreSelector(({ header }) => header.navRoute.length);
  },
  getNavRouteByLevel: (level: number): string | undefined => {
    return useCoreSelector(({ header }) => header.navRoute[level - 1]);
  },
  getIsBackButtonHidden: (): boolean => {
    return useCoreSelector(({ header }) => header.isBackButtonHidden);
  },
  getSettingsTabIndex: (): number => {
    return useCoreSelector(({ header }) => header.settingsTabIndex);
  },
};
